// router/index.js for Vue 3
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/Home.vue';
import AboutPage from '../views/About.vue';

const routes = [
    { path: '/', name: 'Sākums', component: HomePage },
    { path: '/par-karti', name: 'Par karti', component: AboutPage },
    {
        path: '/admin',
        name: 'Administrācija',
        // Atsevišķs chunk — admin kods neapgrūtina publisko lapu.
        component: () => import('../views/Admin.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
